/* ============================================================
   UNOO — app.js
   ============================================================ */

// ── Navbar scroll handler ────────────────────────────────────
(function () {
  const navbar = document.getElementById('navbar');
  if (!navbar) return;

  function onScroll() {
    if (window.scrollY > 20) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  // Run once on load in case page is already scrolled
  onScroll();
})();

// ── Video lazy load ──────────────────────────────────────────
function loadVideo(el) {
  el.innerHTML = '<iframe src="https://www.youtube.com/embed/64iaz5r2NbU?autoplay=1&rel=0&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="position:absolute;inset:0;width:100%;height:100%;border:0;"></iframe>';
  el.onclick = null;
  el.style.cursor = 'default';
}

// ── Popup ────────────────────────────────────────────────────
function openPopup() {
  document.getElementById('contact-popup').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closePopup() {
  document.getElementById('contact-popup').classList.remove('active');
  document.body.style.overflow = '';
}

function closePopupOutside(e) {
  if (e.target === document.getElementById('contact-popup')) closePopup();
}

// Close on Escape key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closePopup();
});


function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  if (!item) return;

  const isOpen = item.classList.contains('open');

  // Close all open items smoothly
  document.querySelectorAll('.faq-item.open').forEach(function(openItem) {
    openItem.classList.remove('open');
  });

  // Open clicked item if it was closed
  if (!isOpen) {
    // Small rAF delay so the close transition starts before open begins
    requestAnimationFrame(function() {
      item.classList.add('open');
    });
  }
}
